const axios = require('axios');

function searchResultHTML(posts) {
  return posts
    .map(
      (post) => `
      <a href='${
        post.proSubCat
          ? `http://${location.host}/${post.proSubCat[0].subcat}`
          : `http://${location.host}/blog`
      }/${post.slug}' class='single-search-result'>
        <strong>${post.title}</strong>
      </a>
    `
    )
    .join('');
}
function typeAhead(search) {
  // eslint-disable-next-line no-useless-return
  if (!search) return;
  const searchInput = search.querySelector('.search-field');
  const searchResult = search.querySelector('.search-result');

  searchInput.on('input', function () {
    if (!this.value) {
      searchResult.style.display = 'none';
      return; // stop!
    }
    searchResult.style.display = 'block';

    axios
      .get(`/api/search?q=${this.value}`)
      .then((res) => {
        if (res.data.length) {
          searchResult.innerHTML = searchResultHTML(res.data);
          return;
        }
        searchResult.innerHTML = `<div class="no-search-result">نتیجه ای برای ${this.value} یافت نشد!!!</div>`;
      })
      .catch((err) => {
        console.error(err);
      });
  });

  // handle keyup event

  searchInput.on('keyup', (e) => {
    if (![38, 40, 13].includes(e.keyCode)) {
      return; // Stop!
    }
    const activeClass = 'search-active-class';
    const current = search.querySelector(`.${activeClass}`);
    const items = search.querySelectorAll('.single-search-result');
    let next;
    if (e.keyCode === 40 && current) {
      next = current.nextElementSibling || items[0];
    } else if (e.keyCode === 40) {
      // eslint-disable-next-line prefer-destructuring
      next = items[0];
    } else if (e.keyCode === 38 && current) {
      next = current.previousElementSibling || items[items.length - 1];
    } else if (e.keyCode === 38) {
      next = items[items.length - 1];
    } else if (e.keyCode === 13 && current.href) {
      window.location = current.href;
    }

    if (current) {
      current.classList.remove(activeClass);
    }
    next.classList.add(activeClass);
  });
}

export default typeAhead;



// WEBPACK FOOTER //
// ./public/javascripts/modules/typeAhead.js